module.exports = ["toEnglish","toEdition"]


//////////////////
// WEBPACK FOOTER
// ../~/espn-url/langs.json
// module id = 831
// module chunks = 0